import { useEffect } from 'react';

const SITE_NAME = 'Print My Parts';

/**
 * Sets the document title to "<pageTitle> | Print My Parts"
 * and restores it to just "Print My Parts" on unmount.
 */
export function usePageTitle(pageTitle: string) {
    useEffect(() => {
        document.title = `${pageTitle} | ${SITE_NAME}`;
        return () => {
            document.title = SITE_NAME;
        };
    }, [pageTitle]);
}
